<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14YxrGI/tc-custom/9783958642645_IMGJPG_FrontCover_0.jpg?1703042611032" alt="This image is the cover for the book Das weiße Haus, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Das weiße Haus, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Herman Joachim Bang (* 20. April 1857 in Asserballe auf der Insel Alsen; † 29. Januar 1912 in Ogden, Utah) war ein dänischer Schriftsteller und Journalist. "Das weiße Haus"  von Herman Bang ist gefüllt mit düsterer Komik, und einem starken Sinn fürs Szenische und einer Erzähltechnik, die weit über die Jahrhundertwende vorausschaut.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Herman Bang
      </h2>
      
      <p class="authorDescription body article">Herman Joachim Bang (* 20. April 1857 in Asserballe auf der Insel Alsen; † 29. Januar 1912 in Ogden, Utah) war ein dänischer Schriftsteller und Journalist. (Wikipedia)</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB Ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4bb402f3